import { Typography } from "@shared/ui.primitives";
import React from "react";

import { verticalProductCardBrandName } from "./VerticalProductCard.css";
import type { ProductCardDataType } from "./types";

type Props = {
  product: Pick<ProductCardDataType, "brandName">;
};

export const VerticalProductCardBrandName: React.FC<Props> = ({ product }) => {
  if (!product?.brandName) return null;

  return (
    <div className={verticalProductCardBrandName}>
      <Typography variant="franchise-md" colour="primary-dark">
        {product.brandName}
      </Typography>
    </div>
  );
};
